import { useReactToPrint } from "react-to-print";
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import AdminNav from "./AdminNav";
import ReceiptCard from "./components/receipt/receipt.component";
import 'utils/jsdocTypes';
import { formatDateMDYString } from "utils/date";

const { useMutation } = require("@apollo/client");
const { useAuth } = require("components/custom/authprovider");
const { GET_ADMINTRANSACTION_DETAILS } = require("graphql/admin/mutations/transactions");
const { useState, useEffect, useRef } = require("react");
const { useParams, useHistory } = require("react-router-dom");
const { default: sendMutationContext } = require("utils/sendContext");

function PrintReceipt() {
  const [isCardLoaded, setIsCardLoaded] = useState(false);
  const componentRef = useRef();
  const handlePrintCfg = {
    contentRef: componentRef,
  };
  const handlePrint = useReactToPrint(handlePrintCfg);

  const history = useHistory();
  const transactionPath = (_ctransactionid) => {
    if (_ctransactionid) {
      return "/admin/tools/transaction-lookup/" + _ctransactionid;
    }

    return "/admin/tools/transaction-lookup";
  };


  const { wt } = useAuth();

  const [logoutFlag, setLogoutFlag] = useState();

  const { ctransactionid } = useParams();
  const [transactionID, setTransactionID] = useState("");

  /**
   * State variable for holding customer data.
   * 
   * @type {[AdminTransactionDetails | undefined, React.Dispatch<React.SetStateAction<Transaction | undefined>>]}
   */
  const [customer, setCustomer] = useState();

  /**
   * State variable for holding transaction data.
   * 
   * @type {[AdminTransactionDetails | undefined, React.Dispatch<React.SetStateAction<Transaction | undefined>>]}
   */
  const [transaction, setTransaction] = useState();

  const [adminTransactionLookup, { loading: loadingAdminTransactionLookup }] = useMutation(GET_ADMINTRANSACTION_DETAILS, sendMutationContext(wt, setLogoutFlag));

  const searchTransaction = async (searchTransactionId = undefined) => {
    if (!logoutFlag) {
      if (transactionID !== "") {
        searchTransactionId = transactionID;
      }

      if (!searchTransactionId || searchTransactionId == "") {
        setCustomer();
        setTransaction();
        return;
      }

      const data = await adminTransactionLookup({ variables: { transactionid: searchTransactionId } });
      if (data && data.data && data.data.adminTransactionLookup.error === null && searchTransactionId) {
        setCustomer(data.data.adminTransactionLookup.customer);
        setTransaction(data.data.adminTransactionLookup.transaction);
      } else {
        setCustomer();
        setTransaction();
      }
    }
  };

  useEffect(() => {
    if (ctransactionid) {
      setTransactionID(ctransactionid);
      searchTransaction(ctransactionid);
    }

    if (logoutFlag) {
      history.push("/admin/logout");
    }
  }, [logoutFlag, history]);

  useEffect(() => {
    if (!loadingAdminTransactionLookup && componentRef.current) {
      handlePrintCfg["documentTitle"] = `Receipt_${formatDateMDYString(transaction.datetimecreated)}_${transaction.referenceid1}`;
      setIsCardLoaded(true);
      handlePrint();
    }
  }, [loadingAdminTransactionLookup]);

  return (
    <div className="admin-wrapper">
      <AdminNav />

      <Container fluid className="content" style={{ color: "#000" }}>
        <Row>
          <Col>
            <Card className="card-dark">
              <CardHeader className="card-header-dark">
                <Row>
                  <Col lg="8" md="6" sm="6">
                    Transaction Receipt
                  </Col>

                  <Col lg="2" md="3" sm="3" style={{ textAlign: "right" }}>
                    <Button
                      color="success"
                      className="toggle-status-btn"
                      onClick={() => history.push(transactionPath(ctransactionid))}
                    >
                      Back to Transaction Lookup
                    </Button>
                  </Col>

                  <Col lg="2" md="3" sm="3" style={{ textAlign: "right" }}>
                    {isCardLoaded ? (
                      <Button
                        color={"success"}
                        onClick={handlePrint}
                      >
                        Print Receipt
                      </Button>
                    ) : (
                        <Button
                          color={"success"}
                          disabled
                        >
                          Print Receipt
                        </Button>
                      )
                    }
                  </Col>
                </Row>
              </CardHeader>
            </Card>
            {!transaction && !loadingAdminTransactionLookup &&
              <CardBody className="content">
                <span>No transaction found!</span>
              </CardBody>
            }

            {loadingAdminTransactionLookup &&
              <CardBody className="content">
                <span>Loading transaction invoice...</span>
              </CardBody>
            }

            {!loadingAdminTransactionLookup && transaction && customer &&
              <ReceiptCard transaction={transaction} customer={customer} ref={componentRef} />
            }
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default PrintReceipt;
